// @ts-expect-error module not typed
import { getInboxId } from 'conversations-internal-schema/inbox/operators/getInboxId';
// @ts-expect-error module not typed
import { getInboxName } from 'conversations-internal-schema/inbox/operators/getInboxName';
import { ConversationHandoffErrorContext } from 'conversations-thread-view/move-to-inbox/context/ConversationHandoffErrorContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext, useEffect } from 'react';
import { assertIsDefined } from 'ui-addon-conversations-settings/utils/assert';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { useInboxes } from 'conversations-thread-data/inboxes/public/hooks';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { jsx as _jsx } from "react/jsx-runtime";
const checkIsMoveToInboxError = error => error && !!error.moveToInboxError;
export const useConversationHandoffErrorAlert = threadId => {
  const {
    threadErrors
  } = useContext(ConversationHandoffErrorContext);
  const {
    asyncInboxes
  } = useInboxes(true);
  const inboxes = getData(asyncInboxes);
  useEffect(() => {
    const threadError = threadErrors[threadId];
    if (inboxes && checkIsMoveToInboxError(threadError)) {
      const moveToInboxError = threadError.moveToInboxError;
      assertIsDefined(moveToInboxError);
      const destinationInboxId = moveToInboxError.variables.newInboxId;
      const destinationInbox = inboxes.find(inbox => getInboxId(inbox) === destinationInboxId);
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.thread-list-member-overlay.inboxChangeRemovalMoveToInboxError",
          options: {
            inboxName: getInboxName(destinationInbox)
          }
        }),
        type: 'danger'
      });
    }
  }, [inboxes, threadErrors, threadId]);
};